// extracted by mini-css-extract-plugin
export default {"root":"RequireAuth_root__MUBXM"};